export const REDUX_FORM_INITIALIZE_ACTION = '@@redux-form/INITIALIZE';
export const REDUX_FORM_DESTROY_ACTION = '@@redux-form/DESTROY';
export const REDUX_FORM_CHANGE_ACTION = '@@redux-form/CHANGE';
export const REDUX_FORM_ARRAY_REMOVE_ACTION = '@@redux-form/ARRAY_REMOVE';
export const REDUX_FORM_ARRAY_PUSH_ACTION = '@@redux-form/ARRAY_PUSH';
